module.exports = __webpack_public_path__ + "static/img/img-about-2.776184b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-about-2.png
// module id = 9bn8
// module chunks = 0